<template>
  <div class="configuration">
    <configuration-edit-modal
      ref="configurationEditModal"
      @onClickSave="refreshList"
    />

    <b-row>
      <configuration-actions @onClickReset="refreshList" />
    </b-row>

    <b-row>
      <b-col>
        <configuration-table
          ref="configurationTable"
          @onClickEditConfiguration="showEditFormModal"
        />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <configuration-status-table ref="configStatusTable" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ConfigurationEditModal from "@/components/nodes/configuration/ConfigurationEditModal";
import ConfigurationTable from "@/components/nodes/configuration/ConfigurationTable";
import ConfigurationActions from "@/components/nodes/configuration/ConfigurationActions";
import ConfigurationStatusTable from "@/components/nodes/configuration/ConfigurationStatusTable";

export default {
  data() {
    return {
      currentView: "",
    };
  },
  components: {
    "configuration-actions": ConfigurationActions,
    "configuration-table": ConfigurationTable,
    "configuration-edit-modal": ConfigurationEditModal,
    "configuration-status-table": ConfigurationStatusTable,
  },
  methods: {
    showEditFormModal(configuration) {
      this.$refs.configurationEditModal.showModal(configuration);
    },

    refreshList() {
      this.$refs.configurationTable.refreshList();
    },
  },
};
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>